module.exports = __webpack_public_path__ + "static/media/Carousels-FNB-Mobile.71143db8.webp";